import * as React from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '~/client/src/shared/components/shadcn-ui/select'

export interface IPropertySelectOption {
  label: React.ReactNode
  value: any
  disabled?: boolean
}

interface IProps {
  options: IPropertySelectOption[]
  value: any
  className?: string
  onChange(value: any): void
}

export default class PropertySelect extends React.Component<IProps> {
  public render() {
    const { options, value, className = '' } = this.props
    const selectedOption = options.find(o => o.value === value)

    return (
      <Select value={value} onValueChange={this.onItemSelect}>
        <SelectTrigger className={`property-select pa8 tw:w-full ${className}`}>
          {selectedOption && selectedOption.label}
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem
              key={String(option.value)}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )
  }

  private onItemSelect = (value: any) => {
    const { onChange } = this.props
    onChange(value)
  }
}
